<script lang="ts" setup>
import { useBodyStore } from '@autobid/nuxt-pinia-store/store/useBodyStore'
import { pastelTheme, useNotivue } from 'notivue'

const { resolution } = storeToRefs(useBodyStore())
const config = useNotivue()
watchEffect(() => {
  config.update(config => ({
    ...config,
    limit: resolution.value.width < 1024 ? 2 : 3,
  }))
})
</script>

<template>
  <Notivue v-slot="item">
    <Notifications :item="item" :theme="pastelTheme" />
  </Notivue>
</template>
